import { takeLatest, put } from 'redux-saga/effects';
import api, { api2 } from '../../../../utils/apiConfig';
import SubscribeActionTypes from './types';
import {
  subscribeSuccess,
  // subscribeFailure,
  subscribeLogSuccess,
  subscribeLogFailure,
  getWalletBalanceSuccess,
  getWalletBalanceFailure,
  initiateRazorPaySuccess,
  initiateRazorPayFailure,
  completeRazorPayFailure,
  completeRazorPaySuccess,
  subscriptionPay,
  subscriptionpayFailure,
  subscriptionPaySuccess,
  getWalletBalanceStart,
} from './actions';
import UrlConfig from './urls';
import { showSnackBar } from '../../../../components/UI/HOC/SnackBar/store/actions';
import { redirectionFunction } from '../../../../utils/utils';

function* postLogSubscribe(action: any) {
  const requestURL = UrlConfig.logSubscription();
  try {
    const response = yield api.post(requestURL, action.payload);
    yield put(subscribeLogSuccess(response));
  } catch (e) {
    yield put(subscribeLogFailure(e));
    console.log({ e });
  }
}

// function* postSubscribe(action: any) {
//   const requestURL = UrlConfig.saveSubscription();
//   try {
//     const response = yield api.post(requestURL, action.payload);
//     yield put(subscribeSuccess(response));
//   } catch (e) {
//     yield put(subscribeFailure(e));
//     console.log({ e });
//   }
// }
function* getWalletBalance(action: any): any {
  const requestURL = UrlConfig.getWalletBalance();
  try {
    const response = yield api.get(requestURL);

    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      // yield put((response?.data?.message || 'Something went wrong'));
    } else {
      yield put(getWalletBalanceSuccess(response.data));
    }
  } catch (e) {
    yield put(getWalletBalanceFailure());
    console.log(e);
  }
}
function* initiateRecharge(action: any): any {
  const requestURL = UrlConfig.initiatePaymentRecharge();
  const amountInPaisa = action.payload.amountInPaisa;
  const formData = {
    amountInPaisa,
  };
  try {
    const response = yield api.post(requestURL, formData);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
    } else {
      yield put(initiateRazorPaySuccess(response.data));
    }
  } catch (e) {
    yield put(initiateRazorPayFailure());
    console.log({ e });
  }
}
function* completeRecharge(action: any): any {
  const requestURL = UrlConfig.completePaymentRecharge();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(completeRazorPayFailure());
    } else {
      const { status, balanceInPaisa, message } = response.data;
      if (status === 'SUCCESS') {
        // demandID
        yield put(
          showSnackBar({
            variant: 'success',
            message: `Recharge successfully done`,
          }),
        );
        yield put(completeRazorPaySuccess(response));
        yield put(subscriptionPay());
      } else {
        yield put(
          showSnackBar({
            variant: 'error',
            message: `Recharge: ${status}`,
          }),
        );
      }
    }
  } catch (e) {
    yield put(completeRazorPayFailure());

    console.log({ e });
  }
}
function* subscriptionPayment(action: any): any {
  let medium = sessionStorage.getItem('pageMedium');
  const requestURL = UrlConfig.subscribe();
  const fromData = {
    medium: medium,
  };
  try {
    const response = yield api2.post(requestURL, fromData);

    if (response.data) {
      yield put(subscriptionPaySuccess());
      yield put(subscribeSuccess(response.data));
      sessionStorage.removeItem('pageMedium');

      yield put(
        showSnackBar({
          variant: 'success',
          message: `बधाई हो ! आप लोड सदस्य बन चुके है`,
        }),
      );
      const { redirect, subscriptionValidity } = response.data;
      redirectionFunction(redirect ?? null, subscriptionValidity ?? null);
    }
  } catch (e) {
    yield put(subscriptionpayFailure());
    console.log({ e });
  }
}

function* subscribeSaga() {
  // yield takeLatest(SubscribeActionTypes.SUBSCRIBE_START, postSubscribe);
  yield takeLatest(SubscribeActionTypes.SUBSCRIBE_LOG_START, postLogSubscribe);
  yield takeLatest(SubscribeActionTypes.GET_BALANCE, getWalletBalance);
  yield takeLatest(SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT, initiateRecharge);
  yield takeLatest(SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT, completeRecharge);
  yield takeLatest(SubscribeActionTypes.SUBSCRIBE_PAY, subscriptionPayment);
}

export default subscribeSaga;
